import React from "react";
import { BookOpenIcon, GiftIcon, GlobeIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { CheckList } from "../CheckList";
import { Countdown } from "../Countdown";
import { ScarcityBar } from "../ScarcityBar";
import { images, offerIncludes } from "../../data/content";
export function OfferSection() {
  return <section id="offer" className="bg-paper px-4 py-16 md:py-24" data-id="element-264" data-mp="al5y01fy03ki">
      <div className="mx-auto max-w-5xl" data-id="element-265" data-mp="6hzsiw0nmgf3">
        <header className="text-center" data-id="element-266" data-mp="1qhtidi6ypwr">
          <p className="inline-block rounded-full bg-cta px-4 py-1.5 font-display text-sm font-black uppercase tracking-wide text-white" data-id="element-267" data-mp="1pgfq19sjpbc">
            Exclusive launch offer
          </p>
          <h2 className="mx-auto mt-4 max-w-3xl text-balance font-display text-[28px] font-black uppercase leading-[1.1] text-ink md:text-5xl" data-id="element-268" data-mp="3nyhg1llyorzj">
            Everything you need to organize your shoulder assessments
          </h2>
          <p className="mt-3 text-lg text-muted" data-id="element-269" data-mp="3exjj1n9xxkqg">Here’s everything included with your purchase.</p>
        </header>

        <div className="mt-10 grid gap-6 lg:grid-cols-[1fr_1.05fr] lg:items-start" data-id="element-270" data-mp="1apxn8r1osbi1">
          <div className="space-y-6" data-id="element-271" data-mp="1fkbld17qgwqe">
            <img src={images.mockup} alt="Complete Shoulder Assessment Blueprint collection" className="mx-auto w-full max-w-lg" data-id="element-272" data-mp="10tuozw9ygx0d" />
            <div className="rounded-2xl bg-white p-5 ring-1 ring-line md:p-6" data-id="element-273" data-mp="15s5tdrhhefb7">
              <h3 className="flex items-center gap-2 font-display text-lg font-black uppercase text-ink" data-id="element-274" data-mp="1ti07sdhg8bxk">
                <BookOpenIcon className="h-5 w-5 text-brand" aria-hidden="true" data-id="element-275" data-mp="1yi4n406mf0m7" />
                The complete 6-volume collection
              </h3>
              <div className="mt-4" data-id="element-276" data-mp="1khk3j1svt0rn">
                <CheckList items={offerIncludes.volumes} data-id="element-277" data-mp="1oj5g0m1i7d1b" />
              </div>
              <h3 className="mt-6 flex items-center gap-2 font-display text-lg font-black uppercase text-ink" data-id="element-278" data-mp="1ol9tnvp7fqes">
                <GiftIcon className="h-5 w-5 text-cta" aria-hidden="true" data-id="element-279" data-mp="d49ymsbh2xh2" />
                Plus 5 specialized bonuses
              </h3>
              <div className="mt-4" data-id="element-280" data-mp="2fpvvq67rcycs">
                <CheckList items={offerIncludes.bonuses} color="#FF6A13" data-id="element-281" data-mp="2ft04zi02ykab" />
              </div>
            </div>
          </div>

          <div className="overflow-hidden rounded-3xl bg-white shadow-[0_20px_50px_-20px_rgba(10,27,51,0.35)] ring-2 ring-cta" data-id="element-282" data-mp="260uignslkv2i">
            <div className="bg-navy px-5 py-5 text-center" data-id="element-283" data-mp="210zrkk8to5hg">
              <p className="font-display text-sm font-extrabold uppercase tracking-wide text-gold" data-id="element-284" data-mp="1x0fufgo911vb">Your complete collection</p>
              <p className="mt-2 text-sm leading-relaxed text-white/80" data-id="element-285" data-mp="1s136esln5or5">
                Six educational volumes, five practical resources, and a structured collection focused on the
                assessment of shoulder pain.
              </p>
            </div>
            <div className="space-y-6 p-5 md:p-7" data-id="element-286" data-mp="1i5jaw7azos2x">
              <div className="text-center" data-id="element-287" data-mp="3heznlk4jrazf">
                <p className="font-display text-base font-extrabold uppercase text-muted" data-id="element-288" data-mp="3hdwx3db4zak1">
                  Get the complete collection today for just…
                </p>
                <p className="mt-1 font-display text-8xl font-black leading-none text-good" data-id="element-289" data-mp="3kxyfb3fweuts">$27</p>
                <p className="mt-2 font-display text-base font-black uppercase tracking-wide text-ink" data-id="element-290" data-mp="3oxz5tmg9uwh7">One-time payment</p>
              </div>

              <CheckList items={offerIncludes.perks} color="#14935A" data-id="element-291" data-mp="2jxvh8k7azt7" />

              <div className="flex items-start gap-3 rounded-xl bg-brand-light p-4" data-id="element-292" data-mp="2mbsvo2cso3x">
                <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-293" data-mp="3215kh2r31lxc" />
                <p className="text-sm leading-snug text-ink" data-id="element-294" data-mp="3617qfo3up1if">
                  <strong data-id="element-295" data-mp="3azrblmame99q">Automatic currency conversion:</strong> the price is converted to your local currency at
                  checkout, where supported.
                </p>
              </div>

              <ScarcityBar data-id="element-296" data-mp="qal4xy9rlxhv" />

              <CtaButton label="Yes! I want Shoulder Assessment Blueprint™" data-id="element-297" data-mp="q9a1y0o58trt" />
              <Countdown data-id="element-298" data-mp="v7ts6d9rsrpz" />

              <p className="text-center text-sm text-muted" data-id="element-299" data-mp="v71v0y0iylxl">
                One-time payment · Instant digital access · Lifetime access to purchased files
              </p>
              <p className="flex items-center justify-center gap-2 text-center text-sm font-semibold text-ink" data-id="element-300" data-mp="1z7ryt5qkw0ho">
                <ShieldCheckIcon className="h-4 w-4 text-good" aria-hidden="true" data-id="element-301" data-mp="2d82uqn6qw59p" />
                Secure checkout · Digital educational resources
              </p>
            </div>
          </div>
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center text-base leading-relaxed text-muted" data-id="element-302" data-mp="2n2usps48ou50">
          Instead of searching through disconnected notes and resources, you’ll have a dedicated collection designed
          around the shoulder assessment process.
        </p>
      </div>
    </section>;
}